import React from 'react';

import DealsPage from '../components/DealsPage';

const DealsApp = (props) => (
  <DealsPage {...props} />
);

export default DealsApp;
